// extracted by mini-css-extract-plugin
export default {"gif":"n_7","gif--wrapped":"n_8"};